/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_Analytics_AnalyticsDashboardDto } from '../models/Routemize_DTOs_Analytics_AnalyticsDashboardDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AnalyticsDashboardService {
    /**
     * @param startDate
     * @param endDate
     * @param userId
     * @param compareWithPreviousPeriod
     * @returns Routemize_DTOs_Analytics_AnalyticsDashboardDto OK
     * @throws ApiError
     */
    public static getApiAppAnalyticsDashboardGetDashboard(
        startDate: string,
        endDate: string,
        userId?: string,
        compareWithPreviousPeriod?: boolean,
    ): CancelablePromise<Routemize_DTOs_Analytics_AnalyticsDashboardDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/analyticsDashboard/getDashboard',
            query: {
                'StartDate': startDate,
                'EndDate': endDate,
                'UserId': userId,
                'CompareWithPreviousPeriod': compareWithPreviousPeriod,
            },
        });
    }
}
